module.exports = __webpack_public_path__ + "omniv2/img/ui-search-2.e21d5d5e.svg";